import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const assistantFileConfirmUploadMutationAtom = createMutationAtomFactory(
  'assistant.fileConfirmUpload',
  ({ fileId }: { fileId: string }) => ({
    filesConfirmFileUpload: {
      __args: {
        fileID: fileId,
      },
      id: true,
      fileName: true,
      mimeType: true,
      status: true,
    },
  }),
);
